import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/vigor-alimentos-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-2ce63b94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-3 py-md-5" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-3 col-lg-3 text-center order-2 d-flex align-items-center justify-content-center position-relative" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid d-block m-auto mt-3 logo-footer",
  alt: "marcas",
  src: _imports_0
}, null, -1))
const _hoisted_6 = { class: "d-flex align-items-center justify-content-center justify-content-md-between mt-3" }
const _hoisted_7 = {
  target: "_blank",
  href: "https://www.facebook.com/VigorBrasil/"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  target: "_blank",
  href: "https://www.instagram.com/vigorbrasil/"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  target: "_blank",
  href: "https://www.youtube.com/c/vigorbrasil"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  target: "_blank",
  href: "https://www.linkedin.com/company/vigor-alimentos/"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "col-md-9 col-lg-9 col-xl-8 order-md-2" }
const _hoisted_16 = {
  key: 0,
  class: "list-group list-group-horizontal-md text-center flex-wrap"
}
const _hoisted_17 = { class: "list-group-item ps-0" }
const _hoisted_18 = {
  key: 0,
  href: "https://www.danubio.com.br/",
  target: "_blank"
}
const _hoisted_19 = {
  key: 1,
  href: "https://faixaazul.com.br/",
  target: "_blank"
}
const _hoisted_20 = { class: "list-group list-group-horizontal-md text-center flex-wrap" }
const _hoisted_21 = { class: "list-group-item ps-0" }
const _hoisted_22 = { class: "list-group-item" }
const _hoisted_23 = { class: "list-group-item" }
const _hoisted_24 = { class: "list-group-item" }
const _hoisted_25 = { class: "list-group-item" }
const _hoisted_26 = { class: "list-group-item" }
const _hoisted_27 = { class: "row mt-3" }
const _hoisted_28 = { class: "col-md-7 col-lg-6" }
const _hoisted_29 = { class: "text-center text-md-start" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "tel:0800-724-6433",
  class: "btn btn-primary sac me-md-3 mb-2"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "0800-724-6433")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center text-md-start" }, "Priorize o contato através do e-mail:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:sac@vigor.com.br",
  class: "btn btn-primary sac my-2 m-md-0"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "sac@vigor.com.br")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 col-lg-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center text-md-start" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Contato com Encarregado de Dados Pessoais (DPO):"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Maristela Marquiafave")
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:privacidade@vigor.com.br",
    class: "btn btn-primary sac"
  }, [
    /*#__PURE__*/_createElementVNode("strong", null, "privacidade@vigor.com.br")
  ])
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_35 = { class: "row my-3 align-items-center" }
const _hoisted_36 = { class: "col-md-12 col-lg-4" }
const _hoisted_37 = { class: "m-0 text-center text-md-start" }
const _hoisted_38 = { class: "col-md-4 col-lg-3 mt-3 mt-md-0" }
const _hoisted_39 = ["placeholder"]
const _hoisted_40 = { class: "col-md-4 col-lg-3 mt-3 mt-md-0" }
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = { class: "col-md-3 col-lg-2 mt-3 mt-md-0" }
const _hoisted_43 = {
  type: "submit",
  class: "btn btn-primary w-100 w-md-auto"
}
const _hoisted_44 = { class: "col-12" }
const _hoisted_45 = { class: "m-0" }
const _hoisted_46 = { class: "list-group list-group-horizontal flex-wrap align-items-center d-none d-md-flex" }
const _hoisted_47 = { class: "list-group-item ps-0 pe-0" }
const _hoisted_48 = { class: "list-group-item pe-0" }
const _hoisted_49 = { class: "list-group-item pe-0" }
const _hoisted_50 = {
  class: "link",
  href: "https://www.contatoseguro.com.br/vigor",
  target: "_blank"
}
const _hoisted_51 = { class: "list-group-item pe-0 me-2" }
const _hoisted_52 = ["href"]
const _hoisted_53 = { class: "list-group-item m-xxl-auto" }
const _hoisted_54 = {
  href: "https://sa365.ag/",
  target: "_blank"
}
const _hoisted_55 = ["src"]
const _hoisted_56 = { class: "list-group-item" }
const _hoisted_57 = { class: "m-0" }
const _hoisted_58 = { class: "row d-block d-md-none" }
const _hoisted_59 = { class: "col-12" }
const _hoisted_60 = { class: "list-group flex-wrap text-center" }
const _hoisted_61 = { class: "list-group-item ps-0" }
const _hoisted_62 = { class: "list-group-item" }
const _hoisted_63 = { class: "list-group-item" }
const _hoisted_64 = {
  class: "link",
  href: "https://www.contatoseguro.com.br/vigor",
  target: "_blank"
}
const _hoisted_65 = { class: "list-group-item" }
const _hoisted_66 = ["href"]
const _hoisted_67 = { class: "list-group-item" }
const _hoisted_68 = {
  href: "https://sa365.ag/",
  target: "_blank"
}
const _hoisted_69 = ["src"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "list-group-item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "© 2022 Todos os direitos reservados.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Separator = _resolveComponent("Separator")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Separator, { color: "#fafafa" }),
    _createElementVNode("footer", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                class: "link",
                to: "/"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("a", _hoisted_7, [
                  _createElementVNode("img", {
                    class: "img-fluid d-block me-3",
                    style: {"max-width":"18px"},
                    alt: "Facebook",
                    src: require('@/assets/img/Facebook.svg')
                  }, null, 8, _hoisted_8)
                ]),
                _createElementVNode("a", _hoisted_9, [
                  _createElementVNode("img", {
                    class: "img-fluid d-block me-3",
                    style: {"max-width":"18px"},
                    alt: "Instagram",
                    src: require('@/assets/img/Instagram.svg')
                  }, null, 8, _hoisted_10)
                ]),
                _createElementVNode("a", _hoisted_11, [
                  _createElementVNode("img", {
                    class: "img-fluid d-block me-3",
                    style: {"max-width":"18px"},
                    alt: "YouTube",
                    src: require('@/assets/img/Youtube.svg')
                  }, null, 8, _hoisted_12)
                ]),
                _createElementVNode("a", _hoisted_13, [
                  _createElementVNode("img", {
                    class: "img-fluid d-block",
                    style: {"max-width":"18px"},
                    alt: "Linkedin",
                    src: require('@/assets/img/Linkedin.svg')
                  }, null, 8, _hoisted_14)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_ctx.marcasFooter)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                  _createElementVNode("li", _hoisted_17, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('footer.nossas-marcas')), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marcasFooter, (marcaFooter, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "list-group-item",
                      key: index
                    }, [
                      (marcaFooter.name == 'Danubio')
                        ? (_openBlock(), _createElementBlock("a", _hoisted_18, _toDisplayString(marcaFooter.name), 1))
                        : (marcaFooter.name == 'Faixa Azul')
                          ? (_openBlock(), _createElementBlock("a", _hoisted_19, _toDisplayString(marcaFooter.name), 1))
                          : (_openBlock(), _createBlock(_component_router_link, {
                              key: 2,
                              class: "link",
                              to: { name: 'Brands Amigavel', params: { name_brand: marcaFooter.slug } }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(marcaFooter.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_20, [
              _createElementVNode("li", _hoisted_21, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t('footer.institucional')), 1)
              ]),
              _createElementVNode("li", _hoisted_22, [
                _createVNode(_component_router_link, {
                  class: "link",
                  to: "/nossa-historia"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('footer.nossa-historia')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_23, [
                _createVNode(_component_router_link, {
                  class: "link",
                  to: "/nossas-lojas"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('footer.nossas-lojas')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_24, [
                _createVNode(_component_router_link, {
                  class: "link",
                  to: "/nossa-cultura"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('nossa-cultura.nossa-cultura')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_25, [
                _createVNode(_component_router_link, {
                  class: "link",
                  to: "/exportacao"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('footer.exportacao')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_26, [
                _createVNode(_component_router_link, {
                  class: "link",
                  to: "/imprensa"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('footer.imprensa')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("p", _hoisted_29, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('footer.atendimento')), 1)
                ]),
                _hoisted_30,
                _hoisted_31,
                _hoisted_32
              ]),
              _hoisted_33
            ]),
            _hoisted_34,
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitNewsletterFooter && _ctx.onSubmitNewsletterFooter(...args)), ["prevent"])),
              id: "form-newsletter-footer"
            }, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("p", _hoisted_37, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('footer.newsletter')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["form-control", { error: _ctx.v$.name.$error }]),
                    placeholder: _ctx.$t('footer.seu-nome'),
                    name: "name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formFooter.name) = $event))
                  }, null, 10, _hoisted_39), [
                    [_vModelText, _ctx.formFooter.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: _normalizeClass(["form-control", { error: _ctx.v$.email.$error }]),
                    placeholder: _ctx.$t('footer.seu-email'),
                    name: "email",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formFooter.email) = $event))
                  }, null, 10, _hoisted_41), [
                    [_vModelText, _ctx.formFooter.email]
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("button", _hoisted_43, _toDisplayString(_ctx.$t('footer.registre-se')), 1)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.formFooter.resposta), 1)
                ])
              ])
            ], 32),
            _createElementVNode("ul", _hoisted_46, [
              _createElementVNode("li", _hoisted_47, [
                _createVNode(_component_router_link, {
                  class: "link",
                  to: "/politica-de-privacidade"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('footer.politica-de-privacidade')) + " |", 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_48, [
                _createVNode(_component_router_link, {
                  class: "link",
                  to: "/nossa-cultura"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('footer.etica')) + " |", 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_49, [
                _createElementVNode("a", _hoisted_50, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('footer.linha-etica')) + " |", 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_51, [
                _createElementVNode("a", {
                  href: _ctx.publicPath + 'assets/pdf/Politica_de_qualidade.pdf',
                  target: "_blank",
                  class: "link"
                }, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('privacyPolicy.botao-politica-qualidade')), 1)
                ], 8, _hoisted_52)
              ]),
              _createElementVNode("li", _hoisted_53, [
                _createElementVNode("a", _hoisted_54, [
                  _createElementVNode("img", {
                    class: "img-fluid d-block logo-sa365 m-auto",
                    alt: "SA365 Logo",
                    src: require('@/assets/img/SA365-logo.svg')
                  }, null, 8, _hoisted_55)
                ])
              ]),
              _createElementVNode("li", _hoisted_56, [
                _createElementVNode("p", _hoisted_57, "© 2022 " + _toDisplayString(_ctx.$t('footer.todos-direitos-reservados')) + ".", 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("ul", _hoisted_60, [
              _createElementVNode("li", _hoisted_61, [
                _createVNode(_component_router_link, {
                  class: "link",
                  to: "/politica-de-privacidade"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('footer.politica-de-privacidade')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_62, [
                _createVNode(_component_router_link, {
                  class: "link",
                  to: "/nossa-cultura"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('footer.etica')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_63, [
                _createElementVNode("a", _hoisted_64, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('footer.linha-etica')), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_65, [
                _createElementVNode("a", {
                  href: _ctx.publicPath + 'assets/pdf/Politica_de_qualidade.pdf',
                  target: "_blank",
                  class: "link"
                }, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('privacyPolicy.botao-politica-qualidade')), 1)
                ], 8, _hoisted_66)
              ]),
              _createElementVNode("li", _hoisted_67, [
                _createElementVNode("a", _hoisted_68, [
                  _createElementVNode("img", {
                    class: "img-fluid d-block logo-sa365 m-auto",
                    alt: "SA365 Logo",
                    src: require('@/assets/img/SA365-logo.svg')
                  }, null, 8, _hoisted_69)
                ])
              ]),
              _hoisted_70
            ])
          ])
        ])
      ])
    ])
  ], 64))
}